import { render, staticRenderFns } from "./problemDetail.vue?vue&type=template&id=9c4a17de"
import script from "./problemDetail.vue?vue&type=script&lang=js"
export * from "./problemDetail.vue?vue&type=script&lang=js"
import style0 from "./problemDetail.vue?vue&type=style&index=0&id=9c4a17de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports